import * as React from 'react';
import { FormField, ArticleHeading1, Image } from '@cian/ui-kit';
import * as styles from './Summary.css';
import { MortgageCalculatorTooltip } from '../../../MortgageCalculatorTooltip';

interface ISummaryProps {
  rateTitle: string;
  rateValue: string;
  tooltip?: string;
  loanPayment: string;
  requiredIncome: string;
  logo?: string;
}

export function Summary({ rateTitle, rateValue, tooltip, loanPayment, requiredIncome, logo }: ISummaryProps) {
  return (
    <div>
      {logo && (
        <div className={styles['logo']}>
          <Image src={logo} width={150} height={50} />
        </div>
      )}
      <FormField label={rateTitle}>
        <ArticleHeading1>
          <mark className={styles['rate']} data-testid="SummaryRate">
            {rateValue}
          </mark>
          {tooltip && <MortgageCalculatorTooltip text={tooltip} />}
        </ArticleHeading1>
      </FormField>

      <div className={styles['row']}>
        <FormField label="Ежемесячный платеж">
          <ArticleHeading1 color="white_100">{loanPayment}</ArticleHeading1>
        </FormField>
        <FormField label="Необходимый доход">
          <ArticleHeading1 color="white_100">{requiredIncome}</ArticleHeading1>
        </FormField>
      </div>
    </div>
  );
}
